import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "valueChange", "onChange", "label", "error", "errMessage", "size", "placeholder"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { Analytics, AssignmentIndOutlined, Bolt, CommuteOutlined, Computer, Description, Domain, Language, LocalPoliceOutlined, MonetizationOnOutlined, SlowMotionVideo, SupervisorAccountOutlined, TravelExploreOutlined, VerifiedUser, WebAsset } from '@mui/icons-material';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import clsx from 'clsx';
import lodash from 'lodash';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Registry of the selectable icons, keyed by the PascalCase @mui/icons-material
 * component name stored in form/server data (iconName). Add new icons here when
 * more become selectable.
 */
export var JOVE_ICON_SELECT_ICON_MAP = {
  Analytics: Analytics,
  AssignmentIndOutlined: AssignmentIndOutlined,
  Bolt: Bolt,
  CommuteOutlined: CommuteOutlined,
  Computer: Computer,
  Description: Description,
  Domain: Domain,
  Language: Language,
  LocalPoliceOutlined: LocalPoliceOutlined,
  MonetizationOnOutlined: MonetizationOnOutlined,
  SlowMotionVideo: SlowMotionVideo,
  SupervisorAccountOutlined: SupervisorAccountOutlined,
  TravelExploreOutlined: TravelExploreOutlined,
  VerifiedUser: VerifiedUser,
  WebAsset: WebAsset
};
export var JOVE_ICON_SELECT_OPTIONS = Object.keys(JOVE_ICON_SELECT_ICON_MAP).map(function (iconName) {
  return {
    value: iconName,
    label: iconName
  };
});

var renderIconOption = function renderIconOption(iconName) {
  var IconComponent = iconName ? JOVE_ICON_SELECT_ICON_MAP[iconName] : undefined;
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-row items-center space-x-2",
    children: [IconComponent ? /*#__PURE__*/_jsx(IconComponent, {
      fontSize: "small"
    }) : null, /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      children: iconName || ''
    })]
  });
};

var JoveIconSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      valueChange = props.valueChange,
      onChange = props.onChange,
      label = props.label,
      error = props.error,
      errMessage = props.errMessage,
      size = props.size,
      placeholder = props.placeholder,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(''),
      uid = _useState[0],
      setUid = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setUid(lodash.uniqueId());
  }, []);
  /**
   * methods
   */

  var selectValueChangeAction = function selectValueChangeAction(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(e.target.value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs(FormControl, {
      className: "relative",
      size: size,
      error: error,
      children: [!!label && /*#__PURE__*/_jsx(InputLabel, {
        id: uid + '-label',
        size: size,
        children: label
      }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, rest), {}, {
        ref: ref,
        id: uid,
        labelId: uid + '-label',
        label: label,
        value: value || '',
        onChange: selectValueChangeAction,
        size: size,
        placeholder: placeholder,
        displayEmpty: true,
        renderValue: function renderValue(selected) {
          return renderIconOption(selected);
        },
        children: JOVE_ICON_SELECT_OPTIONS.map(function (item) {
          return /*#__PURE__*/_jsx(MenuItem, {
            value: item.value,
            children: renderIconOption(item.value)
          }, item.value);
        })
      }))]
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveIconSelectControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveIconSelect, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveIconSelect;